import React from 'react'
import NavbarComp from '../../components/navbar/navbar'
import SidebarComp from '../../components/sidebar/sidebar'
import AllDriverMainComp from '../../components/body/alldatacomponent/driver/alldrivermaincomp'

const AllDriverScreen = () => {
    return (
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <AllDriverMainComp />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllDriverScreen